export const skipForwardProp = (propsToSkip: string | string[]) => (prop: string) => {
  const propsList = Array.isArray(propsToSkip) ? propsToSkip : [propsToSkip];

  return !propsList.includes(prop);
};
